import MainView from 'js/views/main';

import {
  initializeDatepickers,
  formatDate,
  computeEndDate,
  DatePicker,
} from 'js/utils/datepicker';
import { calendarDayDiff } from 'pmn/utils/dateTime';

export default class View extends MainView {
  dayCount!: number;
  endDateField: HTMLElement | null = null;
  pickers: DatePicker[] = [];

  mount(): void {
    super.mount();

    const dayCountField = document.querySelector<HTMLInputElement>(
      '#user_novena_day_count',
    );
    if (dayCountField) {
      this.dayCount = parseInt(dayCountField.value, 10);
    }

    this.endDateField = document.getElementById('user_novena_end_date');

    this.pickers = initializeDatepickers({
      onSelect: (value) => {
        const todayDateStr = document.querySelector<HTMLInputElement>('#today_date')?.value;
        if (!todayDateStr) { throw new Error('today_date input not found'); }
        const calendarDiff = calendarDayDiff(value, todayDateStr);

        const selectedTodayElement = document.querySelector('#selected_today');
        if (calendarDiff === 0) {
          selectedTodayElement?.classList.add('visible');
        } else {
          selectedTodayElement?.classList.remove('visible');
        }

        const selectedPastElement = document.querySelector('#selected_past');
        if (calendarDiff < 0) {
          selectedPastElement?.classList.add('visible');
        } else {
          selectedPastElement?.classList.remove('visible');
        }

        this.updateEndDate(value);
      },
    });

    const [startDatePicker] = this.pickers;
    if (startDatePicker) {
      const date = startDatePicker.picker.getDate();
      if (date) {
        this.updateEndDate(date);
      }
    }
  }

  unmount(): void {
    super.unmount();
  }

  updateEndDate(value: Date): void {
    if (!this.endDateField) {
      return;
    }
    const updatedDate = computeEndDate(value, this.dayCount);
    this.endDateField.innerText = formatDate(updatedDate);
  }
}
